
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.tabbed-solutions__help {
  display: none;

  @include media-query(tablet) {
    display: inherit;
    margin-top: 40px;
  }
}

.solutions {
  /* Disable outline when clicking inside the tab panel */
  & :global([data-reach-tab-panel]:not([data-focus-visible-added])) {
    outline: 0;
  }
}

// This adds additional padding for \`For most businesses\` tab in VBP&P 1.1 pricing page
#tabs--1--panel--0 > .plan-column-group-wrapper {
  padding-bottom: 60px;
}
`